import * as Amplitude from '@amplitude/analytics-browser';

import type { UniverseReference, User } from '@wecasa/common/src/types/commons';
import { getCurrentCountry } from '@wecasa/common/src/utils/country';
import { formatStandardDateDeprecated } from '@wecasa/common/src/utils/date';
import { formatLocaleToPreciseLocale } from '@wecasa/common/src/utils/locale';

import type { BasketMode } from '@wecasa/customer/src/types/basket';

import { getI18nLocale } from '@wecasa/i18n';

import type { MembershipEvent } from '@wecasa/membership/src/types/tracking';

import { getScreenNameForTrackingByLocationPathname } from '../utils/tracking';

type TrackMembershipEventParams = {
  eventType: MembershipEvent;
  user?: User;
  universeReference?: UniverseReference;
  path: string;
  mode: BasketMode;
  additionalData?: { [key: string]: any };
};

export const trackMembershipEvent = ({
  eventType,
  user,
  universeReference,
  path,
  mode,
  additionalData = {},
}: TrackMembershipEventParams) => {
  const screenName = getScreenNameForTrackingByLocationPathname({
    pathname: path,
    universeReference,
  });
  const country = getCurrentCountry();

  Amplitude.track(eventType, {
    screen: screenName,
    source: 'WebFunnel',
    universe: universeReference,
    country,
    locale: formatLocaleToPreciseLocale({ locale: getI18nLocale(), country }),
    mode,
    userPublicId: user?.public_id,
    membershipStatus: user?.membership?.status,
    membershipOrigin: user?.membership?.origin,
    membershipCreatedAt: user?.membership?.created_at
      ? formatStandardDateDeprecated(user.membership.created_at)
      : undefined,
    ...additionalData,
  });
};
